import { render, staticRenderFns } from "./ListArticles.vue?vue&type=template&id=f42b51e8&"
import script from "./ListArticles.vue?vue&type=script&lang=js&"
export * from "./ListArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports